import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react'
import { logOut } from './authSlice'
import { baseUrl, prepareHeaders } from '../../config/apiConfig'

const baseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders,
})

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions)

  // if (result?.error?.status === 401) {
  //     // send refresh token to get new access token
  //     const refreshResult = await baseQuery('/refresh', api, extraOptions);
  //     if (refreshResult?.data) {
  //         const user = result.data?.data.token.accessToken
  //         localStorage.setItem('token', result.data?.data.token.accessToken)
  //         // store the new token
  //         api.dispatch(setCredentials({ ...refreshResult.data, user }))
  //         // retry the original query with new access token
  //         result = await baseQuery(args, api, extraOptions)
  //     } else {
  //         api.dispatch(logOut())
  //     }
  // }

  if (
    result?.error?.status === 401 &&
    (!window.location.href.includes('/login') &&
      !window.location.href.includes('/register-supplier') &&
      !window.location.href.includes('/register-company'))
  ) {
    api.dispatch(logOut())
    return
  }

  return result
}

export const tokenSlice = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({}),
})
